import React, { useEffect, useRef, useState } from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import './index.scss';

const VISIBLE_MS = 4000;
const FADE_MS = 250;

export default function TipAnimation({ username, amount, currency = 'SIKI', profileImg, onComplete }) {
  const [visible, setVisible] = useState(true);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onCompleteRef.current?.(), FADE_MS);
    }, VISIBLE_MS);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className={`tip-animation-container ${visible ? 'visible' : 'hidden'}`}>
      <Avatar
        src={profileImg || undefined}
        alt=""
        className="tip-avatar"
        imgProps={{ loading: 'lazy' }}
      >
        {username?.[0]?.toUpperCase() || '?'}
      </Avatar>
      <Box className="tip-text">
        <Typography component="span" className="tip-username">
          {username}
        </Typography>
        <Typography component="span" className="tip-amount">
          {amount} {currency}
        </Typography>
      </Box>
    </Box>
  );
}
